module.exports = __webpack_public_path__ + "static/undraw_Data_points_ubvs-5394aa8122d3946f93cafd54577e8d26.svg";